import {useAuth} from './Auth'
import {isOnPremisesInstallation} from './onPremisesAccess'

/**
 * Whether the signed-in install is an on-premises one (the bank's, «فاش»). It has none of ASA's cloud services:
 * کارپوشه, buyer links, periodic reports, alerts and the notification centre, the wallet, online payment and the
 * value-added services' tariffs, fees and marks (the user, 1405/07/25: «روی پروژه فاش سرویس کارپوشه و لینک و
 * گزارش دوره ایی و اعلان و ... نداریم کلن»).
 */
export const useIsOnPremises = (): boolean => isOnPremisesInstallation(useAuth().currentUser)
